import { INLINE_SEARCH_FILTER_TYPE } from "search-filter/constants";
import isFilterInaccessible from "search-filter/logic/isFilterInaccessible";
const transformToInlineFilter = (filter) => {
  const updatedFilter = { ...filter };
  delete updatedFilter.id;
  updatedFilter.type = INLINE_SEARCH_FILTER_TYPE;
  return updatedFilter;
};
const transformInaccessibleFilters = (filters, isPermitted) => filters.map((filter) => {
  if (isFilterInaccessible(filter, isPermitted)) {
    return transformToInlineFilter(filter);
  }
  return filter;
});
export default transformInaccessibleFilters;
